import React from 'react';

import FieldCheckbox from '../fields/FieldCheckbox';
import FieldRadioSelect from '../fields/FieldRadioSelect';
import FieldText from '../fields/FieldText';
import FieldSelect from '../fields/FieldSelect';
import FieldNumber from '../fields/FieldNumber';
import FieldCheckboxSelect from '../fields/FieldCheckboxSelect';
import FieldCheckboxSelectWithQuantity from '../fields/FieldCheckboxSelectWithQuantity';
import FieldDisguisedRadioList from '../fields/FieldDisguisedRadioList';
import StepHorizontalField from './StepHorizontalField';
import store from '../../../store/configuration';
import Configurator from '../../../model/configurator/Configurator';

const fieldTypeMapping = {
    'checkbox': FieldCheckbox,
    'radio-select': FieldRadioSelect,
    'multiselect': FieldCheckboxSelect,
    'multiselectWithQuantity': FieldCheckboxSelectWithQuantity,
    'select': FieldSelect,
    'text': FieldText,
    'number': FieldNumber,
    'checkbox-radio-select': FieldDisguisedRadioList
}

export default class Step extends React.Component {
    constructor(props) {
        super(props)

        this.stepModel = this.constructor.getStepModel(props.model)

        if (this.stepModel) {
            let configurator = Configurator.getInstance()
            this.stepModel.editor = configurator.getEditor()

            if (configurator.getStepsManager().hasStepModel(this.stepModel.name) === false) {
                this.fields = this.constructor.getFields(this.stepModel)
                this.firstVisibleField = this.constructor.getFirstVisibleField(this.fields);
                this.lastVisibleField = this.constructor.getLastVisibleField(this.fields);
                this.stepModel.initialize(this.fields, this.firstVisibleField, this.lastVisibleField);
                configurator.getStepsManager().addStepModel(this.stepModel.name, this.stepModel)
            } else {
                this.fields = configurator.getStepsManager().getStepByName(this.stepModel.name)._fields
            }
        }
    }

    stepAboutToBecomeInvisible() {
    }

    stepAboutToBecomeVisible() {
    }

    render() {
        return (
            <React.Fragment>
                {this.renderBody(this.props.model)}
            </React.Fragment>
        )
    }

    renderBody(model) {
        throw new Error('NotImplementedError: Step#renderBody.')
    }

    /**
     * Renders a field with store updater attached to it.
     *
     * @private
     * @param {Object} field
     * @param {Object} additionalProps
     * @return {React}
     */
    renderField = (field, additionalProps = {}) => {
        if (field === undefined) {
            return <React.Fragment></React.Fragment>
        }

        if (field.visible === false) {
            return <React.Fragment></React.Fragment>
        }

        const FieldComponent = fieldTypeMapping[field.type]
        if (FieldComponent) {
            const changeCallback = newValue => {

                // Specifying undefined as a value will make JS remove the property completely,
                // which will cause problems during transformation.
                if (newValue !== undefined) {
                    field.value = newValue
                }

                if (additionalProps.onPostChange) {
                    additionalProps.onPostChange(newValue)
                }

                if (this.onFormModelChange) {
                    this.onFormModelChange()
                } else {
                    this.props.onFormModelChange()
                }
            }

            return (
                <FieldComponent onChange={changeCallback} {...field} {...additionalProps} />
            )
        }

        console.warn('Component for field type: ' + field.type + ' was not found.')

        return <React.Fragment></React.Fragment>
    }

    renderFieldv2 = (field, additionalProps = {}) => {
        if (field === undefined || field.visible === false) {
            return <React.Fragment></React.Fragment>
        }

        const FieldComponent = fieldTypeMapping[field.type]
        if (FieldComponent) {
            const changeCallback = newValue => {

                let shouldUpdateStore = true

                if (field.onChange) {
                    shouldUpdateStore = field.onChange(newValue)

                    if (shouldUpdateStore === undefined) {
                        shouldUpdateStore = true
                    }
                }

                // Specifying undefined as a value will make JS remove the property completely,
                // which will cause problems during transformation.
                if (shouldUpdateStore && newValue !== undefined) {
                    field.value = newValue
                }

                store.recentlyChangedField = field.getModelPath()

                if (this.onFormModelChange) {
                    this.onFormModelChange()
                } else {
                    this.props.onFormModelChange()
                }
            }

            return (
                <FieldComponent
                    ref={element => field.setRef(element)}
                    onChange={changeCallback}
                    step={this.stepModel}
                    field={field}
                    {...(field.getComponentProperties())}
                    {...additionalProps}
                />
            )
        }

        console.warn('Component for field type: ' + field.type + ' was not found on field: ' + field)

        return <React.Fragment></React.Fragment>
    }

    getDefaultValueFromList(field) {
        let defaultItem = field.items && field.items.find(x => (x.attributes || {}).default);
        return defaultItem ? defaultItem.value : undefined
    }

    renderSection() {
        var renderSectionValue = false;
        for (let i = 0; i < arguments.length; i++) {
            if (arguments[i] && arguments[i].visible == true)
                renderSectionValue = true;

        }

        return renderSectionValue;

    }

    renderGenericHorizontalField = (field, additionalProps = {}, tips = [], customDefaultButtonClick = undefined, className = undefined, renderAdditionalFilters = undefined) => {

        if (!field.visible) {
            return <React.Fragment></React.Fragment>
        }

        let hasDefaultItem = false
        let onDefaultButtonClick = () => {
        }

        if (field.disabled === false && field.readonly === false) {
            let defaultValue = this.getDefaultValueFromList(field)
            if (defaultValue === undefined)
                defaultValue = field.default

            if (defaultValue !== undefined && ((field.items !== undefined && field.items.length > 1) || field.items === undefined)) {
                hasDefaultItem = true

                onDefaultButtonClick = customDefaultButtonClick
                if (!onDefaultButtonClick) {
                    onDefaultButtonClick = () => {
                        field.value = defaultValue

                        if (this.onFormModelChange) {
                            this.onFormModelChange()
                        } else {
                            this.props.onFormModelChange()
                        }
                    }
                }
            }
        }

        const renderFieldFunc = ('__temporary_dis' in field) ? this.renderFieldv2 : this.renderField;
        additionalProps = {...additionalProps};

        return (
            <StepHorizontalField
                className={className}
                label={field.label}
                unit={field.unit}
                description={field.description}
                visible={field.visible}
                readonly={field.readonly || (field.items !== undefined && field.items.length === 1)}
                defaultButtonVisible={hasDefaultItem}
                onDefaultButtonClick={onDefaultButtonClick}
                inputTips={tips}
                renderAdditionalFilters={renderAdditionalFilters}>{renderFieldFunc(field, additionalProps)}</StepHorizontalField>
        )
    }

    /**
     * Returns whether all specified fields have a value.
     * @param  {...any} fields
     */
    doFieldsHaveValues = (...fields) => {
        let fieldsWithValues = fields.find(field => field.value)
        if (fieldsWithValues && fieldsWithValues.length) {
            return fieldsWithValues.length === fields.length
        }

        return (typeof fieldsWithValues !== 'undefined')
    }

    /**
     *
     * @param step {StepModel}
     * @returns {{}}
     */
    static getFields(step) {
        return {}
    }

    static getFirstVisibleField() {
        return null
    }

    static getLastVisibleField() {
        return null
    }

    /**
     *
     * @param model
     * @returns {StepModel | null}
     */
    static getStepModel(model) {
        return null
    }
}